import gsap from 'gsap';
import React, { createRef, useEffect } from 'react';
import styled from 'styled-components';
import { IconBase } from '../Base';
const Wrapper = styled.div `
  --download-arrow-x: 0px;
  --download-arrow-y: 0px;
  --download-line-x: 0px;
  --download-line-offset: 0px;
  --download-circle-offset: 48px;
  --download-arrow-line-offset: 22px;
  --download-arrow-top-offset: 24px;
  --download-circle-scale: 1;
`;
const Arrow = styled.g `
  transform: translate(var(--download-arrow-x), var(--download-arrow-y));
`;
const ArrowTop = styled.path `
  stroke-dasharray: 12px;
  stroke-dashoffset: var(--download-arrow-top-offset);
`;
const ArrowLine = styled.path `
  stroke-dasharray: 11px;
  stroke-dashoffset: var(--download-arrow-line-offset);
`;
const Circle = styled.path `
  stroke-dasharray: 48px;
  stroke-dashoffset: var(--download-circle-offset);
  transform: scale(var(--download-circle-scale)) translateZ(0);
  transform-origin: 50% 50%;
`;
const Line = styled.path `
  stroke-dasharray: 8px;
  stroke-dashoffset: var(--download-line-offset);
  transform: translateX(var(--download-line-x));
`;
export const IconDownload = (props) => {
    const wrapperRef = createRef();
    const triggerDone = () => {
        if (props.onDone) {
            props.onDone();
        }
    };
    useEffect(() => {
        if (props.running) {
            const wrapper = wrapperRef.current;
            if (!wrapper) {
                return;
            }
            gsap.to(wrapper, {
                keyframes: [
                    {
                        '--download-arrow-y': '-1.5px',
                        duration: 0.15,
                    },
                    {
                        '--download-arrow-y': '0px',
                        duration: 0.1,
                    },
                    {
                        '--download-line-offset': '8px',
                        '--download-line-x': '4px',
                        duration: 0.15,
                    },
                    {
                        '--download-circle-offset': '0px',
                        duration: 0.4,
                        onStart: () => {
                            gsap.to(wrapper, {
                                '--download-arrow-line-offset': '11px',
                                '--download-arrow-top-offset': '21px',
                                '--download-arrow-x': '-1px',
                                '--download-arrow-y': '-2px',
                                duration: 0.15,
                            });
                        },
                    },
                    {
                        '--download-circle-scale': 1.05,
                        duration: 0.15,
                    },
                    {
                        '--download-circle-scale': 1,
                        duration: 0.2,
                        onComplete: () => {
                            gsap.to(wrapper, {
                                '--download-arrow-x': '0px',
                                '--download-arrow-y': '0px',
                                '--download-line-x': '0px',
                                '--download-line-offset': '0px',
                                '--download-circle-offset': '48px',
                                '--download-arrow-line-offset': '22px',
                                '--download-arrow-top-offset': '24px',
                                duration: 0.2,
                                delay: 1,
                                onComplete: triggerDone,
                            });
                        },
                    },
                ],
            });
        }
    }, [props.running]);
    return (React.createElement(Wrapper, { className: props.className, ref: wrapperRef },
        React.createElement(IconBase, null,
            React.createElement("g", { fill: "none", strokeWidth: "1.5", strokeLinecap: "round", strokeLinejoin: "round", style: { stroke: 'var(--icon-color)' } },
                React.createElement(Arrow, null,
                    React.createElement(ArrowLine, { d: "M10 3V14" }),
                    React.createElement(ArrowTop, { d: "M6 10L10 14L14 10" })),
                React.createElement(Circle, { d: "M10 17.5C14.1421 17.5 17.5 14.1421 17.5 10C17.5 5.85786 14.1421 2.5 10 2.5C5.85786 2.5 2.5 5.85786 2.5 10C2.5 14.1421 5.85786 17.5 10 17.5Z" }),
                React.createElement(Line, { d: "M6 17.5H14" })))));
};
//# sourceMappingURL=Download.js.map